import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-local-campaign-conditions-modal',
  templateUrl: './local-campaign-conditions-modal.component.html',
  styleUrls: ['./local-campaign-conditions-modal.component.scss']
})
export class LocalCampaignConditionsModalComponent implements OnInit {

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
  }

}
